/**
 * Pure-data English catalogue for namespace 'templates', core part (W2-05; imports only core/util/types): the failure
 * reasons and notes `applyTemplate` (templates.ts, `TEMPLATE_MSG`) produces as MessageRefs, so they translate wherever
 * the core runs (workers included). The dialog's own strings are in src/features/easing/templates.messages.ts (same
 * namespace, disjoint keys).
 */

import type { MessageCatalog } from '../util/types';

const catalog: MessageCatalog = {
  ns: 'templates',
  locale: 'en',
  messages: {
    'reason.lineMissing': 'The line no longer exists.',
    'reason.durationInvalid': 'The template needs a duration longer than zero, starting at beat 0 or later.',
    'reason.notLayered': 'This template changes size or colour, which have no layers: it cannot go on a new layer.',
    'reason.paramInvalid': 'The value of "{name}" is not usable here.',
    'reason.colorInvalid': 'Choose a colour such as #ff8000.',
    'reason.pointMissing': 'Choose the point to move to.',
    'note.thicknessSkipped':
      'The thickness of a normal line has no keyframe value that looks like no keyframe, so it was left alone: only the length pulses.',
    'note.colorFixed':
      'The line now has colour keyframes: Phira stops showing its AP/FC indicator colour on it and shows the default line colour before and after the flash.',
    'note.noParent': 'This line has no parent: it orbits the screen centre.',
    'note.xyLinked':
      'Position X and Y are linked on this line: the other axis got keyframes at the same beats and keeps its motion.',
    'note.otherLayers': 'Other layers of this property still add to the result.',
    'note.baseChanges':
      'The keyframes under the new layer change again from beat {beat}: the offset stays, so the result moves with them from there.',
    'note.alphaNegative':
      'The opacity under the new layer changes again from beat {beat} and then adds up to less than 0: Phira hides the line and its notes there. Apply it without a new layer, or add keyframes to the new layer at that beat.',
  },
};

export default catalog;
